import DemandStudioCommentCard from "./DemandStudioCommentCard";
import DemandStudioRestoreAllModal from "./DemandStudioRestoreAllModal";
import DemandStudioDeleteCommentsButton from "./DemandStudioDeleteCommentsButton";
import { useDemandStudioContext } from "../../contexts/DemandStudioContext";
import { TOUR_TARGETS } from "../../constants/tourTargets";

const scrollbarClasses =
  "[&::-webkit-scrollbar]:w-0.5 " +
  "[&::-webkit-scrollbar-track]:bg-transparent " +
  "[&::-webkit-scrollbar-thumb]:bg-border " +
  "[&::-webkit-scrollbar-thumb]:rounded-full";

const colRightClasses =
  `flex flex-col gap-4 overflow-y-auto min-h-0 pr-2 pb-6 ${scrollbarClasses}`;

const headerRowClasses = "flex justify-between items-center";
const headerActionsClasses = "flex gap-2";
const colHeadingClasses =
  "text-base font-bold uppercase tracking-[calc(var(--spacing)*0.2)] text-subtle mb-0";

const DemandStudioRevisionComments = () => {
  const { visibleSectionComments } = useDemandStudioContext();

  return (
    <div className={colRightClasses} data-tour={TOUR_TARGETS.DEMAND_STUDIO_COMMENTS}>
      <div className={headerRowClasses}>
        <h6 className={colHeadingClasses}>Revision Comments</h6>
        <div className={headerActionsClasses}>
          <DemandStudioDeleteCommentsButton />
        </div>
      </div>
      {visibleSectionComments.map((section, index) => (
        <DemandStudioCommentCard
          key={section.id}
          section={section}
          index={index}
        />
      ))}
      <DemandStudioRestoreAllModal />
    </div>
  );
};

export default DemandStudioRevisionComments;
